module.exports = __webpack_public_path__ + "static/img/Suri-suri 170cm.8ce343e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Suri-suri 170cm.jpg
// module id = 105
// module chunks = 1